// src/hooks/useParametrizacaoKanban.ts
import { useCallback, useState } from 'react';
import { apiGet } from '../services/api';
import { Loja } from '../types/parametrizacao/Loja';
import { ParametrizacaoOpcao } from '../constants';
import { usePaginatedFetch } from './usePaginatedFetch';

export const useParametrizacaoKanban = () => {
  const [selectedOption, setSelectedOption] = useState<ParametrizacaoOpcao | ''>('');
  const [showKanban, setShowKanban] = useState(false);

  const fetchSemCadastro = useCallback(async (page: number) => {
    const res = await apiGet(`/v1/lojas-connection?semCadastro=true&page=${page}&size=10`);
    const items: Loja[] = res.data.content || res.data;
    const totalItems = res.data.page?.totalElements ?? items.length;
    return { items, totalItems };
  }, []);

  // Coluna "Loja Cadastrada" = só ativas. `filtro=ATIVAS` explícito (== default do
  // backend, então paridade) deixa a intenção clara após a introdução do `filtro`.
  const fetchCadastrada = useCallback(async (page: number) => {
    const res = await apiGet(`/v1/lojas-acesso?filtro=ATIVAS&page=${page}&size=10`);
    return { items: res.data.content as Loja[], totalItems: res.data.page.totalElements };
  }, []);

  // Coluna "Lojas Inativas" = só inativas (filtro=INATIVAS, honrado pelo backend).
  const fetchInativas = useCallback(async (page: number) => {
    const res = await apiGet(`/v1/lojas-acesso?filtro=INATIVAS&page=${page}&size=10`);
    return { items: res.data.content as Loja[], totalItems: res.data.page.totalElements };
  }, []);

  const semCadastro = usePaginatedFetch<Loja>({
    fetchFunction: fetchSemCadastro,
    pageSize: 10,
    enabled: showKanban,
  });

  const cadastrada = usePaginatedFetch<Loja>({
    fetchFunction: fetchCadastrada,
    pageSize: 10,
    enabled: showKanban,
  });

  const inativas = usePaginatedFetch<Loja>({
    fetchFunction: fetchInativas,
    pageSize: 10,
    enabled: showKanban,
  });

  // Recarrega as 3 colunas após mutação (cadastro / inativar / reativar):
  // a loja muda de coluna, então todas precisam refletir o novo estado.
  const reloadColumns = () => {
    semCadastro.reset();
    cadastrada.reset();
    inativas.reset();
  };

  return {
    selectedOption,
    setSelectedOption,
    showKanban,
    setShowKanban,
    semCadastro,
    cadastrada,
    inativas,
    reloadColumns,
  };
};
